import styled from 'styled-components';

export const Header = styled.header`
  height: 60px;
  background-color: var(--brand-primary);
  border-bottom: 1px solid var(--brand-primary-border);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 var(--space-5);
  position: sticky;
  top: 0;
  z-index: 100;
`;

export const HeaderTitle = styled.h1`
  font-size: var(--font-size-h1);
  font-weight: var(--font-weight-bold);
  color: var(--text-inverse);
  margin: 0;
  line-height: var(--line-height-h1);
`;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-2);
`;

export const Footer = styled.footer`
  height: 80px;
  background-color: var(--ui-surface-light);
  border-top: 1px solid var(--ui-divider);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-3) var(--space-5);
  margin-top: auto;
`;

export const FooterLeft = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-2);
`;

export const FooterRight = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-2);
`;

export const Main = styled.main`
  flex: 1;
  overflow: auto;
  padding: var(--space-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--ui-canvas);
`;

export const ContentWrapper = styled.div`
  padding: var(--space-5);
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
`;

export const Sidebar = styled.aside`
  width: 200px;
  background-color: var(--ui-surface);
  border-right: 1px solid var(--ui-border);
  border-radius: var(--border-radius-large);
  padding: var(--space-2) var(--space-3) var(--space-2) var(--space-2);
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  position: sticky;
  top: 60px;
  height: calc(100vh - 60px);
  overflow-y: auto;
`;

export const NavigationButton = styled.button`
  height: 50px;
  background: transparent;
  color: var(--text-primary);
  border: none;
  border-radius: var(--border-radius-small);
  padding: var(--space-2) var(--space-3);
  font-size: var(--font-size-label);
  font-weight: var(--font-weight-semibold);
  font-family: var(--font-family-primary);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: var(--space-2);
  text-align: left;
  transition: background-color var(--transition-fast);

  &:hover {
    background-color: var(--ui-surface-hover);
  }

  &:active {
    background-color: #D5DBDB;
  }

  &.selected {
    background-color: var(--brand-primary);
    color: var(--text-inverse);

    &:hover {
      background-color: var(--brand-primary-hover);
    }

    &:active {
      background-color: var(--brand-primary-active);
    }
  }

  &:focus-visible {
    outline: 3px solid var(--ui-focus);
    outline-offset: 2px;
  }
`;

export const Grid = styled.div`
  display: grid;
  gap: var(--space-5);
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));

  &.metrics {
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  }

  &.analytics {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }
`;

export const Flex = styled.div`
  display: flex;
  gap: ${props => props.gap || 'var(--space-2)'};
  align-items: ${props => props.align || 'center'};
  justify-content: ${props => props.justify || 'flex-start'};
  flex-direction: ${props => props.direction || 'row'};
  flex-wrap: ${props => props.wrap || 'nowrap'};

  &.vertical {
    flex-direction: column;
  }

  &.stretch {
    width: 100%;
  }

  &.center {
    justify-content: center;
    align-items: center;
  }

  &.space-between {
    justify-content: space-between;
  }

  &.space-around {
    justify-content: space-around;
  }
`;

